import React from 'react';

interface IProps {
  style?: React.CSSProperties | undefined;
  embed: string;
}

export const SocialEmbed: React.FC<IProps> = (props) => {
  const [opacity, setOpacity] = React.useState(0);
  // Portrait full-bleed embeds: TikTok, YouTube Shorts, and Instagram Reels (9:16)
  const isPortrait =
    props.embed.includes('tiktok') ||
    (props.embed.includes('youtube') && props.embed.includes('aspect-ratio: 9/16')) ||
    (props.embed.includes('instagram.com') && props.embed.includes('aspect-ratio: 9/16'));
  React.useEffect(() => {
    window.setTimeout(() => setOpacity(1), 200);
  }, []);
  return (
    <iframe
      srcDoc={`<html><body style="margin:0;overflow:hidden;background:black;">${props.embed}</body></html>`}
      style={{
        width: '100%',
        height: getEmbedHeight(props.embed),
        // Portrait embeds are full-bleed — no max-width constraint.
        // 550px matches the maxwidth set on Twitter oEmbed responses.
        maxWidth: isPortrait ? 'none' : 550,
        opacity: opacity,
        border: 0,
        transitionProperty: 'opacity',
        transitionDuration: '0.6s',
        ...props.style,
      }}
      allowFullScreen={true}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    />
  );
};

const getEmbedHeight = (embed: string) => {
  if (
    embed.includes('//www.instagram.com/embed.js') ||
    embed.includes('instagram.com') ||
    embed.includes('//platform.twitter.com/widgets.js') ||
    embed.includes('//platform.x.com/widgets.js')
  ) {
    return '70%';
  }
  return '100%';
};
